import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import EventForm from "@/components/EventForm";

export default function CreateEvent() {
  const { id } = useParams();
  const editing = Boolean(id);
  const { user, loading: authLoading } = useAuth();
  const nav = useNavigate();

  useEffect(() => { if (!authLoading && !user) nav("/login"); }, [authLoading, user, nav]);

  if (!user) return null;

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">{editing ? "Edit" : "New event"}</div>
      <h1 className="font-display text-4xl text-[#1E3A2F] mt-1">{editing ? "Edit event" : "Bring the community together"}</h1>
      <div className="mt-8">
        <EventForm
          editingId={editing ? id : undefined}
          onSaved={(ev) => nav(`/events/${ev.id}`)}
          onCancel={() => nav(-1)}
        />
      </div>
    </div>
  );
}
